import { render, staticRenderFns } from "./clients.vue?vue&type=template&id=8baa571a&scoped=true"
import script from "./clients.vue?vue&type=script&lang=js"
export * from "./clients.vue?vue&type=script&lang=js"
import style0 from "./clients.vue?vue&type=style&index=0&id=8baa571a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baa571a",
  null
  
)

export default component.exports